<div class="content-wrapper p-0">
	<app-content-header [contentHeader]="contentHeader"></app-content-header>
	<div class="content-body">
		<section class="app-ecommerce-details">
			<div class="card">
				<div class="card-body">
					
                    
						<div class="row">
                           
							<div class="col-md-3">
								<div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>First Name:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.firstName}}</p>
                                    </div>
								</div>
							</div>
							<div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>First Name:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.lastName}}</p>
                                    </div>
								</div>
							
							</div>
                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Email:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.email}}</p>
                                    </div>
								</div>
							
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Mobile:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.mobile}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>User Role:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.userRoles}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Gender:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.gender}}</p>
                                    </div>
								</div>
							</div>

                           

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Date of Birth:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.dateOfBirth}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <div class="col-5 col-form-label">
                                        <label><b>Title:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.title}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Designation:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.designation}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Category:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.subjectArea}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Department:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.department}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Institute:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.institute}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Institute Address:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.instituteAddress}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>User Address:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.address1}} {{user_data?.address2}}</p>
                                    </div>
								</div>
							</div>
							
							
							
							
							
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <div class="col-5 col-form-label">
                                            <label><b>State:</b></label>
                                        </div>
                                        <div class="col-7 col-form-label">
                                            <p class="text-justify">{{user_data?.state_name}}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <div class="col-5 col-form-label">
                                            <label><b>City:</b></label>
                                        </div>
                                        <div class="col-7 col-form-label">
                                            <p class="text-justify">{{user_data?.city_name}}</p>
                                        </div>
                                    </div>
                                </div>
								
						
							
                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Pincode:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{user_data?.pincode}}</p>
                                    </div>
								</div>
							</div>

                            <div class="col-md-3">
                                <div class="form-group">
									<div class="col-5 col-form-label">
                                        <label><b>Registered Date:</b></label>
                                    </div>
                                    <div class="col-7 col-form-label">
                                        <p class="text-justify">{{ user_data?.createdAt | date:"MMM dd, yyyy 'at' hh:mm a" }}</p>
                                    </div>
								</div>
							</div>


							
							
						</div>
						
						
						
						
					
				</div>
			</div>
		</section>
	</div>
</div>

